import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuillViewComponent } from 'ngx-quill';
import { timer } from 'rxjs';
import { showAnimation } from 'src/animations';

@Component({
  selector: 'app-quill-note-type-mismatch-dialog',
  templateUrl: './quill-note-type-mismatch-dialog.component.html',
  styleUrls: ['./quill-note-type-mismatch-dialog.component.css'],
  animations: [ showAnimation ]
})
export class QuillNoteTypeMismatchDialogComponent implements OnInit {

  @ViewChild(QuillViewComponent) quillView: QuillViewComponent;

  currentFormat: 'json' | 'object' | 'text' = 'json';
  convertedNote: string;

  rendered: boolean = true;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) private _initialNote: string,
    private _dialogRef: MatDialogRef<QuillNoteTypeMismatchDialogComponent>
  ) { }

  close = () => this._dialogRef.close(false);
  confirm = () => {
    var html = (this.quillView.editorElem.firstChild as HTMLDivElement).innerHTML;
    this._dialogRef.close(html);
  }

  nextFormat = () => {
    this.rendered = false;
    this.currentFormat = this.currentFormat === 'json'? 'object': this.currentFormat === 'text'? 'json': 'text';
    timer(10).subscribe(() => this.rendered = true);
  }

  ngOnInit(): void {
    this.convertedNote = this._initialNote;
  }

}
